/** Shown when a learner accesses a private course they're not enrolled in. */
import { Link } from 'react-router-dom';
import { motion } from 'motion/react';
import { Lock, ChevronLeft } from 'lucide-react';

const EASE = [0.16, 1, 0.3, 1] as const;

export default function PrivateCoursePage() {
  return (
    <div
      className="relative mx-auto w-full px-6 pb-24"
      style={{ fontFamily: 'var(--font-sans)', maxWidth: 'var(--page-max-width)' }}
    >
      {/* Back link */}
      <motion.div
        className="relative pt-10"
        initial={{ opacity: 0, x: -8 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.3, ease: EASE }}
      >
        <Link
          to="/discover"
          className="group inline-flex items-center gap-1 rounded-md py-1 transition-colors"
          style={{ fontSize: 'var(--text-sm)', color: 'var(--color-text-muted)' }}
        >
          <ChevronLeft
            size={16}
            className="transition-transform duration-200 group-hover:-translate-x-0.5"
          />
          Back to Discover
        </Link>
      </motion.div>

      {/* Content */}
      <motion.div
        className="mt-24 flex flex-col items-center text-center"
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.1, ease: EASE }}
      >
        <div
          className="flex h-16 w-16 items-center justify-center rounded-2xl"
          style={{
            background: 'var(--color-surface-muted)',
            border: '1px solid var(--color-border)',
          }}
        >
          <Lock size={28} style={{ color: 'var(--color-text-muted)' }} />
        </div>

        <h1
          className="mt-6 font-semibold"
          style={{
            fontSize: 'var(--text-xl)',
            color: 'var(--color-text)',
            fontFamily: 'var(--font-sans)',
          }}
        >
          This course is private
        </h1>

        <p
          className="mt-2"
          style={{
            fontSize: 'var(--text-base)',
            color: 'var(--color-text-muted)',
            maxWidth: 400,
            lineHeight: 'var(--leading-relaxed)',
          }}
        >
          Contact your instructor for access to this course.
        </p>
      </motion.div>
    </div>
  );
}
